import { all } from 'redux-saga/effects';

import apiRequestSagas from '@redux/components/ApiRequest/sagas';
import blogSagas from '@screens/Blog/redux/sagas';
import loginSagas from '@screens/SignIn/redux/sagas';
import personalData from '@screens/Profile/redux/sagas';
import documentsCertificates from '@screens/Profile/ProfileDocuments/DocumentsCertificates/redux/sagas';
import documentsUpload from '@screens/Profile/ProfileDocuments/DocumentsUpload/redux/sagas';
import workExperience from '@screens/Profile/ProfileWorkExperience/redux/sagas';
import education from '@screens/Profile/ProfileEducation/redux/sagas';
import skill from '@screens/Profile/ProfileSkill/redux/sagas';
import packageFinder from '@screens/Finder/Package/redux/sagas';
import doctorFinder from '@screens/Finder/Doctor/redux/sagas';
import treatmentFinder from '@screens/Finder/Treatment/redux/sagas';
import facilityFinder from '@screens/Finder/Facility/redux/sagas';
import faqsSagas from '@screens/FAQs/redux/sagas';
import treatmentDetailsSagas from '@screens/Details/Treatment/redux/sagas';
import packageDetailsWatcher from '@screens/Details/Package/redux/sagas';
import doctorDetailsSagas from '@screens/Details/Doctor/redux/sagas';
import facilityDetailsSagas from '@screens/Details/Facility/redux/sagas';
import companyDetailsSagas from '@screens/Details/Company/redux/sagas';
import homeSagas from '@screens/Home/redux/sagas';
import profileSettingsSagas from '@screens/ProfileSettings/redux/sagas';
import forgotPasswordSetSagas from '@screens/ForgotPasswordSet/redux/sagas';
import elasticSearchSagas from '@components/ElasticSearch/redux/sagas';
import campaignSaga from '@components/PopupBanner/redux/sagas';
import candidateCreateSagas from './components/CandidateCreate/sagas';
import forgotPasswordSagas from './components/ForgotPassword/sagas';

export default function* rootSaga(nextCtx) {
  yield all([
    apiRequestSagas(nextCtx),
    loginSagas(nextCtx),
    personalData(nextCtx),
    candidateCreateSagas(nextCtx),
    documentsCertificates(),
    documentsUpload(),
    workExperience(),
    education(),
    doctorFinder(),
    packageFinder(),
    treatmentFinder(),
    facilityFinder(),
    blogSagas(),
    skill(),
    faqsSagas(),
    doctorDetailsSagas(),
    treatmentDetailsSagas(),
    packageDetailsWatcher(),
    facilityDetailsSagas(),
    companyDetailsSagas(),
    forgotPasswordSagas(),
    profileSettingsSagas(),
    forgotPasswordSetSagas(),
    homeSagas(),
    elasticSearchSagas(),
    campaignSaga()
  ]);
}
